import { Directive, HostListener, inject } from '@angular/core';
import { ShiveDialogService } from '../../../core/services/controls/shive-dialog.service';
import { AbsencePlannerEventDialogComponent } from '../dialogs/absence-planner-event-dialog/absence-planner-event-dialog.component';
import { AbsencePlannerEventComponent } from './absence-planner-event.component';
import { take, tap } from 'rxjs/operators';
import { AbsencePlannerEventCrudService } from './services/absence-planner-event-crud.service';
import { ShiveRenderService } from '../../../core/services/rendering/shive-render.service';
import { PlannerEventHovered } from '../utils/absence-planner.constants';
import { AbsencePlannerEventDragResizeService } from './services/absence-planner-event-drag-resize.service';
import { DragOrResizeInteraction } from '../../../shared/data-types/interact.types';

@Directive({
  selector: '[appPlannerEventInteraction]',
  standalone: true,
})
export class AbsencePlannerEventInteractionDirective {
  private isMousePressed = false;

  private readonly shiveDialogService = inject(ShiveDialogService);
  private readonly host = inject(AbsencePlannerEventComponent);
  private readonly plannerEventCrudService = inject(AbsencePlannerEventCrudService);
  private readonly plannerEventDragResizeService = inject(AbsencePlannerEventDragResizeService);
  private readonly shiveRenderService = inject(ShiveRenderService);

  /**
   * Fires when user clicks on a planner event.
   */
  @HostListener('mousedown', ['$event'])
  public mouseDown(event: MouseEvent): void {
    event.stopPropagation();
    this.isMousePressed = true;
  }

  @HostListener('mouseup')
  public mouseUp(): void {
    if (
      this.isMousePressed &&
      this.plannerEventDragResizeService.interaction === DragOrResizeInteraction.None
    ) {
      // Open edit / delete dialog.
      const ref = this.shiveDialogService.open({
        content: AbsencePlannerEventDialogComponent,
        width: 572,
        title: 'Event bearbeiten / löschen',
      });

      const plannerEventId = this.host.plannerEventModel().id;
      const selectedEvent = this.plannerEventCrudService.selectPlannerEvent(plannerEventId);
      ref.content.setInput('plannerEventModel', selectedEvent);

      ref.result
        .pipe(
          tap(() => {
            // Reset
            this.isMousePressed = false;
          }),
          take(1),
        )
        .subscribe();
    }

    this.plannerEventDragResizeService.interaction = DragOrResizeInteraction.None;
  }

  @HostListener('mouseover')
  public mouseEnter(): void {
    const slot = this.host.eventContainer();
    this.shiveRenderService.addClass(slot, PlannerEventHovered);
  }

  @HostListener('mouseleave')
  public mouseLeave(): void {
    const slot = this.host.eventContainer();
    this.shiveRenderService.removeClass(slot, PlannerEventHovered);
  }

  @HostListener('mousemove', ['$event'])
  public stopMouseMovePropagation(event: MouseEvent): void {
    event.stopPropagation(); // Prevents the event from bubbling up to the event container.
  }
}
